import { PegxDocumentContext } from './context';

let pegxDocument: PegxDocumentContext | null = null;

export const getPegxDocumentContext = (): PegxDocumentContext | null => pegxDocument;

export const setPegxDocumentState = (value: PegxDocumentContext | null): void => {
  pegxDocument = value;
};
